module.exports = __webpack_public_path__ + "static/media/futura-condensed-bold-oblique.e6050442.ttf";